import { FEATURE_BITS, BITSET_LEN, bitsetPredeterminadoPorRol, forceFixedPermissions } from './permisos';

export function limitarPermisosAlCreador(bits, parent, superAdmin = false) {
  const source = String(bits || '').padEnd(BITSET_LEN, '0').slice(0, BITSET_LEN);
  if (superAdmin) return forceFixedPermissions(source);
  const limited = source.split('').map((bit, index) => bit === '1' && parent?.[index] === '1' ? '1' : '0').join('');
  return forceFixedPermissions(limited);
}

export function permissionTemplate(name, parent, superAdmin = false) {
  const bits = Array(BITSET_LEN).fill('0');
  if (name === 'Administrador') {
    return limitarPermisosAlCreador(bitsetPredeterminadoPorRol(1), parent, superAdmin);
  }
  const modules = name === 'Consulta' ? ['INICIO','ESTANQUES','DISPOSITIVOS','SENSORES','EFECTORES','ALARMAS','REPORTERIA','ACERCA'] :
    name === 'Operador' ? ['INICIO','ESTANQUES','DISPOSITIVOS','SENSORES','EFECTORES','ALARMAS','REPORTERIA','ACERCA'] :
    ['INICIO','ESTANQUES','DISPOSITIVOS','SENSORES','EFECTORES','AUTOMATIZACION','ALARMAS','REPORTERIA','CONFIGURACIONES','FIRMWARE','ACERCA'];
  Object.entries(FEATURE_BITS).forEach(([feature, position]) => {
    const moduleAllowed = modules.some(m => feature === `${m}_VIEW` || feature.startsWith(`${m}_`));
    const view = feature.endsWith('_VIEW');
    const edit = name === 'Técnico' ? feature.endsWith('_EDIT') : name === 'Operador' &&
      ['EFECTORES_EDIT','ALARMAS_EDIT','ALARMAS_TAB_HISTORIAL_EDIT'].includes(feature);
    const privileged = /RESPALDO|PARAMETRO|USUARIOS_TEMP|OTA/.test(feature);
    if (moduleAllowed && (view || edit) && !privileged && (superAdmin || parent?.[position-1] === '1')) bits[position-1]='1';
  });
  bits[0]='1';
  return limitarPermisosAlCreador(bits.join(''), parent, superAdmin);
}
